import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-table-select',
  templateUrl: './table-select.component.html',
  styleUrls: ['./table-select.component.css']
})
export class TableSelectComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
